module.exports = __webpack_public_path__ + "static/media/tram_tracker.449163b0.jpeg";